import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLayoutTemplate",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, p, _, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--layout-template"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Layout Template",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 1.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 1 5V1.5ZM2 2v2.5h8V2H2Zm5.5 5a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V7Zm1 .5V10H10V7.5H8.5ZM1 7a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1-.5-.5V7Zm1 .5V10h3.5V7.5H2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const V = /* @__PURE__ */ s(c, [["render", u]]);
export {
  V as default
};
//# sourceMappingURL=layout-template.js.map
